<template>
  <el-dialog :visible.sync="visible" title="同步媒体平台" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm"   @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '120px'">
      <div class="line-box">

      <el-form-item  label="媒体" prop="media">
          <el-select v-model="dataForm.media" filterable clearable placeholder="请选择渠道">
            <el-option
                    v-for="item in channels"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>




      <el-form-item label="广告账户Id" class="styW" prop="advertiserId">
        <el-select v-model="dataForm.advertiserId" style="width:200px" filterable  clearable placeholder="请选择账户">
              <el-option
                      v-for="item in advertisersList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
              </el-option>
          </el-select>
      </el-form-item>
      </div>
      <el-form-item>
        <div class="vibox"> 
        
          <video class="video"  v-for="item in videos" :key="item.id" :src="item.videoUrl"   @mouseenter="enter" @mouseleave="out" width="150px" height="150px"  controls>

          </video>
        </div>
        
      </el-form-item>
      
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" :loading="upLoading" @click="dataFormSubmitHandle()">{{upLoading ? '视频同步中' : '确定' }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  props:['videos'],
  data () {
    return {
      citys: [],
      companys:[],
      visible: false,
      channels:[],
      advertisersList:[],
      upLoading:false,
      dataForm: {
        advertiserId:'',
        media:'字节系广告',
        fileIds:this.videos.map(item => item.id),
      }
    }
  },
  computed: {
    dataRule () {
      return {
        advertiserId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        media: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],

    
      }
    }
  },
  methods: {
    init () {
      this.getCityOptions();
      this.getCompanysOptions();
      this.getAdvertisersOptions();
      this.getchannelsOptions();
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    enter(e){
      console.log(e,'enter')
      e.target.play().catch(err => { console.log(err) })
    },
    out(e){
      console.log(e,'out')
      e.target.pause().catch(err => { console.log(err) })
    },
     //初始化渠道下拉框中的选项
     async getchannelsOptions() {
      this.$http.get(`/sys/channels/list`).then(({data: res}) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.channels = [];
        if (res.data != null) {
          res.data.forEach(element => {
            if(element.id == '12' || element.id == '10' || element.id == '15') this.channels.push({label: element.name, value: element.id});
            
          })
        }
      })
    },
      //初始化下拉框中的选项
    async getCityOptions() {
              this.$http.get(`/sys/dict/data/list?dataType=landing_page_city`).then(({ data: res }) => {
                console.log(res)
                  if (res.code !== 0) {
                      return this.$message.error(res.msg)
                  }
                  this.citys=[];
                  if (res.data!=null){
                      res.data.forEach(element => {
                          this.citys.push({label:element.dictLabel,value:element.dictValue})
                      })
                      /*let citys = {}
                      for(let i = 0; i< res.data.length; i++){
                          citys[i].value=res.data[i].dictValue
                          citys[i].label=res.data[i].dictLabel
                      }*/
                  }
              }).catch(() => {})
    },
    //初始化公司下拉框中的选项
    async getCompanysOptions() {
     
        this.$http.get(`/sys/companies/list`).then(({ data: res }) => {
      
            if (res.code !== 0) {
                return this.$message.error(res.msg)
            }
            this.companys=[];
            if (res.data!=null){
                res.data.forEach(element => {
                    this.companys.push({label:element.name,value:element.id})
                })
            }
        }).catch(() => {
         
        })
    },
     //初始化广告主账户下拉框中的选项
     async getAdvertisersOptions() {
        this.$http.get(`/sys/rdadvertiser/list`).then(({data: res}) => {
            if (res.code !== 0) {
                return this.$message.error(res.msg)
            }
            this.advertisersList = [];
            if (res.data != null) {
                res.data.forEach(element => {
                    this.advertisersList.push({label: element.advertiserName, value: element.advertiserId})
                })
            }
        }).catch(() => {
        })
    },
    
   
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/budget/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
     
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.upLoading = true
        if(this.dataForm.media == '字节系广告'){
          this.dataForm.media = this.channels.filter(item => item.label == '字节系广告')[0].value
        };
         
        
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/videomedia/syncMedia', this.dataForm).then(({ data: res }) => {
          this.upLoading = false
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => { this.upLoading = false })
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>

<style scoped lang="scss">
.vibox{

}
.video{
  margin: 0 10px ;
}

</style>
